import { Record, String as RTString, Static } from 'runtypes';
import { DeepPartial } from 'utility-types';
import { buildService } from './decorated-service';

const UnsubscribeService = buildService(
  'nasu-svc/service/return-journey-email-reminder/unsubscribe'
);

const RJProfileUnsubscribeArgs = Record({
  applicationID: RTString
});

export type StaticRJUnsubscribeArgs = Static<typeof RJProfileUnsubscribeArgs>;

export const unsubscribeFromRJProfile = (
  args: DeepPartial<StaticRJUnsubscribeArgs>
): Promise<any> => {
  const validated: StaticRJUnsubscribeArgs = RJProfileUnsubscribeArgs.check(
    args
  );
  return UnsubscribeService.add(validated);
};
